import { Layout } from "antd";
import DashboardChecker from "components/dashboardChecker/DashboardChecker";
import { ICMenuFoldOutlined } from "components/list/ListIcon";
import UserNavbar from "components/navbar/UserNavbar";
import Sidebar from "components/sidebar/Sidebar";
import Spinner from "components/Spinner/Spinner";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useGetNotification } from "utils/hooks/useGetNotification";
import useIntervalCheckDNS from "utils/hooks/useIntervalCheckDNS";
import "./dashboard.less";

const { Header, Sider, Content } = Layout;

const Dashboard = ({ user }) => {
  useGetNotification(user);
  useIntervalCheckDNS(user);
  const [toggle, setToggle] = useState(false);
  if (!user) return <Spinner full />;

  return (
    <div className="dashboard-wrapper">
      <DashboardChecker />
      <Layout>
        <Header className="header-dashboard">
          <UserNavbar />
        </Header>
        <Layout>
          <Sider
            className="dashboard-sider"
            breakpoint="lg"
            width={240}
            collapsible
            trigger={<ICMenuFoldOutlined />}
            theme="light"
            collapsed={toggle}
            onCollapse={(collapsed) => setToggle(collapsed)}>
            <Sidebar />
          </Sider>
          <Layout className="dashboard-layout">
            <Content>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </div>
  );
};

export default Dashboard;
